import { useParams } from 'react-router-dom'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import useInspectorCheckResult from '../../hooks/useInspectorCheckResult'
import SubmissionInfoCard from './components/SubmissionInfoCard'
import SubmissionTeamAnswersCard from './components/SubmissionTeamAnswersCard'
import SubmissionGradesCard from './components/SubmissionGradesCard'

const SubmissionPage = () => {
  const params = useParams<{ checkpointId: string; resultId: string }>()
  const resultId = params.resultId
  const { checkResult, loading, setCheckResult } = useInspectorCheckResult(resultId)

  if (loading || !checkResult) {
    return (
      <div className='flex-page-center'>
        <ThreeDotsLoader />
      </div>
    )
  }

  return (
    <TopNavigationLayoutPageContent type='defaultWithBackButton'>
      <div className='flex-lines' style={{ paddingBottom: '44px' }}>
        <div>
          <h2 className='text--heading-h4'>Сданная работа команды</h2>
        </div>
        <div className='flex-lines' style={{ gap: '24px' }}>
          <SubmissionInfoCard checkResult={checkResult} setCheckResult={setCheckResult} />
          <SubmissionTeamAnswersCard resultId={resultId} />
          <SubmissionGradesCard
            checkResult={checkResult}
            checkpointId={checkResult.checkpointId}
            setCheckResult={setCheckResult}
          />
        </div>
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default SubmissionPage
